import tw, { styled } from "twin.macro";

const ScrollBar = styled.div`
    & {
        scrollbar-width: thin;
        scrollbar-color: transparent transparent;
    }
    &::-webkit-scrollbar {
        width: 10px;
    }
    &::-webkit-scrollbar-track {
        ${tw`bg-transparent m-2`}
    }
    &::-webkit-scrollbar-thumb {
        ${tw`rounded-lg bg-white bg-opacity-50 hover:bg-opacity-75`}
    }
    ${tw`overflow-y-scroll`}
`;

export default ScrollBar;